import React, { useState } from 'react';
import DispatchBoard from './DispatchBoard';
import DispatchDayView from './DispatchDayView';
import DispatchTruckBoard from './DispatchTruckBoard';
import DispatchRunSheet from './DispatchRunSheet';

// ===== DISPATCH PAGE (view switcher shell, 2026-07-29) =====
// The big-CRM multi-view pattern (Jaylen's ask): one dispatch home with
// a Board · Day · Trucks · Run Sheet switcher. The board keeps its whole
// render path untouched — this shell just decides which view mounts and
// hands each a switcher element for its header. Always opens on Board
// (deliberate: the TV wall and Susie's muscle memory both assume the
// board; no persisted view state).
//
// History: App.jsx routed 'dispatch' here from 2026-07-29 until the
// 2026-08-26 "offline pass" commit silently pointed it back at
// DispatchBoard (no changelog note; Jaylen didn't ask for it). Restored
// 2026-09-11. Narrow-window behavior lives INSIDE DispatchBoard
// (dispatch-width.md): under 560px the board shows one day at a time —
// the timeline Day view here is a different tool and stays a tab.

const VIEWS = [
    { key: 'board', label: 'Board' },
    { key: 'day', label: 'Day' },
    { key: 'trucks', label: 'Trucks' },
    { key: 'runsheet', label: 'Run Sheet' },
];

export default function DispatchPage() {
    const [view, setView] = useState('board');

    const switcher = (
        <div className="flex items-center bg-slate-100 rounded-lg p-0.5" role="tablist" aria-label="Dispatch view">
            {VIEWS.map(v => (
                <button key={v.key} role="tab" aria-selected={view === v.key}
                    onClick={() => setView(v.key)}
                    className={`px-3 py-1.5 rounded-md text-xs font-semibold transition-colors ${view === v.key ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}>
                    {v.label}
                </button>
            ))}
        </div>
    );

    if (view === 'day') return <DispatchDayView viewSwitcher={switcher} />;
    if (view === 'trucks') return <DispatchTruckBoard viewSwitcher={switcher} />;
    if (view === 'runsheet') return <DispatchRunSheet viewSwitcher={switcher} />;
    return <DispatchBoard viewSwitcher={switcher} />;
}
